import { cn } from '@/lib/utils'

type Tone = 'success' | 'warning' | 'danger' | 'neutral' | 'info'

const TONE_CLASSES: Record<Tone, string> = {
  success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  warning: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  danger: 'bg-red-500/10 text-red-400 border-red-500/30',
  neutral: 'bg-muted text-muted-foreground border-border',
  info: 'bg-sky-500/10 text-sky-400 border-sky-500/30',
}

export function statusToTone(status: string | undefined): Tone {
  const s = String(status || '').toLowerCase()
  if (s === 'running' || s === 'healthy' || s === 'validated-in-stack' || s === 'active') return 'success'
  if (s === 'starting' || s === 'restarting' || s === 'partial' || s === 'implemented-in-repo') return 'warning'
  if (s === 'exited' || s === 'stopped' || s === 'failed' || s === 'unhealthy') return 'danger'
  if (s === 'paused' || s === 'unknown') return 'neutral'
  return 'info'
}

type Props = {
  status?: string
  tone?: Tone
  label?: string
  className?: string
}

export default function StatusBadge({ status, tone, label, className }: Props) {
  const resolvedTone: Tone = tone ?? statusToTone(status)
  const text = label ?? status ?? '—'
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
        TONE_CLASSES[resolvedTone],
        className,
      )}
    >
      {text}
    </span>
  )
}
